import { useLocation } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { queries } from "../lib/api";
import { useOwnGrants } from "./OwnGrants";
import { GrantDeadlines } from "./GrantDeadlines";
export function WorkspaceDeadlines() {
  const { ownRequests, summarySlot } = useOwnGrants();
  const me = useQuery(queries.me());
  const location = useLocation();
  return (
    <GrantDeadlines
      key={me.data?.subject || me.data?.email}
      requests={ownRequests.data ?? []}
      email={me.data?.email ?? ""}
      subject={me.data?.subject ?? ""}
      summarySlot={summarySlot}
      compact={location.pathname !== "/requests"}
    />
  );
}
